<div (click)="send()">
  <img src="assets/images/img-tala-promo.png" alt="" />
</div>
